import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import fontsource from "./cwTeXKai-zhonly.ttf";
import { DEFAULT_IMAGE_URL } from "../../utils/contrains";

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";

Font.register({
  family: "cwTeXKai",
  src: fontsource,
});

class OutFileModal extends Component {
  static propTypes = {
    item: PropTypes.object,
  };

  getImageUrl = () => {};

  /////////////////////////////////////////////////////////////
  render() {
    const styles = StyleSheet.create({
      fontFamily: "cwTeXKai",
      page: {
        flexDirection: "row",
        fontFamily: "cwTeXKai",
        padding: 30,
      },
      section: { margin: 10, padding: 5 },
      image: {
        width: "300px",
        height: "200px",
        padding: 10,
      },
    });
    const {
      EnrollName,
      EnrollCode,
      Title,
      Description,
      Teams,
      ContactPerson,
      ContactPhone,
      ContactEmail,
      Department,
      ClassroomTwName,
      AttachedfileA,
      AttachedfileB,
    } = this.props.item;
    const pdfname = EnrollCode + EnrollName + ".pdf";
    const doc = (
      <Document>
        <Page size="A4" style={styles.page}>
          <View>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              報名者
            </Text>
            <Text style={{ borderWidth: "1px", padding: "2px" }}>
              <div style={{ fontSize: "14px", padding: "2px" }}>
                {" "}
                <span style={{ color: "red" }}>
                  {EnrollCode}-{EnrollName}
                </span>
                -{Department}-{ClassroomTwName}
              </div>
            </Text>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              團隊成員
            </Text>
            <Text style={{ borderWidth: "1px", padding: "2px" }}>
              <div style={{ fontSize: "12px" }}>{Teams}</div>
            </Text>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              聯絡資訊
            </Text>
            <Text style={{ borderWidth: "1px", padding: "2px" }}>
              <div style={{ fontSize: "12px" }}>
                {ContactPerson} -{" "}
                <span style={{ color: "blue" }}>{ContactPhone}</span> -{" "}
                {ContactEmail}
              </div>
            </Text>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              角色名稱
            </Text>
            <Text style={{ borderWidth: "1px", padding: "2px" }}>
              <div style={{ fontSize: "14px" }}>{Title}</div>
            </Text>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              創作理念
            </Text>
            <Text style={{ borderWidth: "1px", padding: "2px" }}>
              <div style={{ fontSize: "12px" }}>{Description}</div>
            </Text>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              全身立繪
            </Text>
            <div
              style={{
                borderWidth: "1px",
                padding: "2px",
                textAlign: "center",
              }}
            >
              <Image
                style={styles.image}
                src={{
                  uri: DEFAULT_IMAGE_URL + AttachedfileA,
                  method: "GET",
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                  },
                }}
                cache="false"
              />
            </div>
            <Text
              style={{
                backgroundColor: "#000000",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "4px",
              }}
            >
              角色Q版
            </Text>
            <div
              style={{
                borderWidth: "1px",
                padding: "2px",
                textAlign: "center",
              }}
            >
              <Image
                style={styles.image}
                src={{
                  uri: DEFAULT_IMAGE_URL + AttachedfileB,
                  method: "GET",
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                  },
                }}
                cache="false"
              />
            </div>
          </View>
        </Page>
      </Document>
    );
    return (
      <>
        <span>
          {EnrollName}-{EnrollCode}的作品：
        </span>
        <PDFDownloadLink
          document={doc}
          fileName={pdfname}
          className="btn btn-success btn-sm"
        >
          {({ loading }) => (loading ? "產生中....請稍後" : "PDF檔案下載")}
        </PDFDownloadLink>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(OutFileModal);
